export const functionAppSetupFor = (tenantId: string) => {
  return {
    functionAppName: `p0-security-perimeter-${tenantId}`,
    functionAppUrl: `https://p0-security-perimeter-${tenantId}.azurewebsites.net`,
    tokenUrl: `https://login.microsoftonline.com/${tenantId}/v2.0`,
  };
};
